import { render, staticRenderFns } from "./TodoWidget.vue?vue&type=template&id=5ec54d14&"
import script from "./TodoWidget.vue?vue&type=script&lang=js&"
export * from "./TodoWidget.vue?vue&type=script&lang=js&"
import style0 from "./TodoWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports